import React from "react";
import './MedicationHistory.scss'

import { Form, Col, Button } from "react-bootstrap";
import { useTranslation } from "../../../i18n/TranslationProvider";

const MedicationHistory = ({ medications, onAddMedication, onDeleteMedication, onChange, unsavedChanges, onSubmit }) => {
    const { t } = useTranslation();
    // Only labels are translated — saved values ("yes"/"no", "No Problems", …) stay English
    return (
        <div className='medication-history-container'>
            <Form.Label>{t("dashboard.medicationHistory.header")}</Form.Label>

            {medications.map((med, index) => (
                <div className='medication-item' key={index}>
                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label>{t("dashboard.medicationHistory.medicationType")}</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder={t("dashboard.medicationHistory.enter")}
                                value={med.medication}
                                onChange={(e) => onChange(e, index, 'medication')}
                            />
                        </Form.Group>

                        <Form.Group as={Col}>
                            <Form.Label>{t("dashboard.medicationHistory.currentlyUsing")}</Form.Label>
                            <Col>
                                <Form.Check
                                    inline
                                    label={t("dashboard.followUpForm.yes")}
                                    type="radio"
                                    name={`curUsing-${index}`}
                                    value="yes"
                                    checked={med.curUsing === 'yes'}
                                    onChange={(e) => onChange(e, index, 'curUsing')}
                                />
                                <Form.Check
                                    inline
                                    label={t("dashboard.followUpForm.no")}
                                    type="radio"
                                    name={`curUsing-${index}`}
                                    value="no"
                                    checked={med.curUsing === 'no'}
                                    onChange={(e) => onChange(e, index, 'curUsing')}
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>{t("dashboard.medicationHistory.tolerance")}</Form.Label>
                            <Col>
                                <Form.Check
                                    type="radio"
                                    label={t("dashboard.medicationHistory.noProblems")}
                                    name={`tolerance-${index}`}
                                    value="No Problems"
                                    checked={med.tolerance === "No Problems"}
                                    onChange={(e) => onChange(e, index, 'tolerance')}
                                />
                                <Form.Check
                                    type="radio"
                                    label={t("dashboard.medicationHistory.sideEffects")}
                                    name={`tolerance-${index}`}
                                    value='Experienced Side Effects'
                                    checked={med.tolerance === 'Experienced Side Effects'}
                                    onChange={(e) => onChange(e, index, 'tolerance')}
                                />
                            </Col>
                        </Form.Group>
                        <Col xs="auto" className="align-self-center">
                            <Button variant="outline-danger" onClick={() => onDeleteMedication(index)} aria-label={t("dashboard.medicationHistory.delete")}>
                                X
                            </Button>
                        </Col>
                    </Form.Row>
                </div>
            ))}

            {unsavedChanges &&
                <Form.Text className='mt-1 mb-1'>
                    {t("dashboard.medicationHistory.pendingChanges")}
                </Form.Text>
            }

            <Form.Row className='justify-content-between'>
                <Col xs="auto">
                    <Button variant="outline-primary" onClick={onAddMedication} aria-label={t("dashboard.medicationHistory.add")}>
                        +
                    </Button>
                </Col>
                {unsavedChanges &&
                    <Col xs="auto">
                        <Button variant="outline-primary" onClick={onSubmit}>
                            {t("common.save")}
                        </Button>
                    </Col>
                }
            </Form.Row>
        </div>
    )
}

export default MedicationHistory;